import { AgGridReactProps } from '@ag-grid-community/react';
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ActionTypes, AgGridColumnDef, SecondaryApiTypeEnum } from '@tassat/common-definitions';
import { Lock as LockIcon } from '@tassat/icon';
import CoreMsg from '@tassat/payments-definitions';
import { ConfirmationWorkflowContext } from '@tassat/workflow';
import React from 'react';

import { LOCK_ICON_COLOR } from 'Lib/constant';
import ActionsDropdownMenu from 'SharedComponents/actionsDropdownMenu/actionsDropdownMenu';
import { useFeatures } from 'SharedComponents/hooks/useFeatures';

interface IActionButtonsAGGridProps extends AgGridReactProps{
    //Column passed in for data should be object that contains the IsLocked value
    data: CoreMsg;
    value: any;
    getValue: () => any;
    colDef: AgGridColumnDef;
    actionButtonOptions: {
        hasDelete: boolean;
        hasLock: boolean;
    };
    isClient?: boolean;
}

const muiStyles = makeStyles({
    root: { height: '100%' },
    lockContainer: { lineHeight: 'initial' },
    showActionsButton: { marginLeft: 'auto' as const }
});

export function ActionButtonsCellRenderer(props: IActionButtonsAGGridProps) {
    const {
        data,
        value,
        getValue,
        colDef
    } = props;

    const { preActionValidationAndConfig } = React.useContext(ConfirmationWorkflowContext).confirmationWorkflowState;
    const [feature] = useFeatures();

    if (
        feature.fireblocks.api && colDef.cellRendererParams?.isClient && 'apiConnection' in data &&
        data.apiConnection?.['APISecondaryConnectionType'] !== SecondaryApiTypeEnum.FIREBLOCKS
    ) {
        return <div />;
    }

    const classes = muiStyles(props);

    let locked = false;
    if (preActionValidationAndConfig[ActionTypes.lock] && preActionValidationAndConfig[ActionTypes.unlock]) {
        locked = value ? getValue().IsLocked : data['IsLocked'];
    }

    if (!preActionValidationAndConfig) return <div />;
    if (!colDef && !colDef.cellRendererParams && !colDef.cellRendererParams.actionButtonOptions) return <div />;

    return (
        <Grid
            alignItems='center'
            className={classes.root}
            container
            direction='row'
            justifyContent='space-between'
            spacing={0}
            wrap='nowrap'
        >
            {locked &&
                <Grid
                    className={classes.lockContainer}
                    item
                >
                    <LockIcon
                        iconColor={LOCK_ICON_COLOR}
                    />
                </Grid>}
            <Grid
                className={classes.showActionsButton}
                item
            >
                <ActionsDropdownMenu
                    data={data}
                    locked={locked}
                />
            </Grid>
        </Grid>
    );
}

export default (ActionButtonsCellRenderer);